import { render } from "./TvmPreLoader.vue?vue&type=template&id=0260d10c&scoped=true"
import script from "./TvmPreLoader.vue?vue&type=script&lang=js"
export * from "./TvmPreLoader.vue?vue&type=script&lang=js"

import "./TvmPreLoader.vue?vue&type=style&index=0&id=0260d10c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0260d10c"],['__file',"src/Components/ChatWidget/TvmPreLoader/TvmPreLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0260d10c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0260d10c', __exports__)) {
    api.reload('0260d10c', __exports__)
  }
  
  module.hot.accept("./TvmPreLoader.vue?vue&type=template&id=0260d10c&scoped=true", () => {
    api.rerender('0260d10c', render)
  })

}


export default __exports__